import { FC } from 'react';
import { AccountsInfo } from '../AccountsViewDrawer/AccountsViewDrawer';
import moment from 'moment';
import { IAccountDrawerStep } from '../AccountsViewDrawer/interfaces';

export const PersonalInfoStep: FC<IAccountDrawerStep> = ({ account, editedValues, setEditedValues }) => {
    const onChange = (key: string, value: string | boolean | number) => {
        setEditedValues({
            ...editedValues,
            verificationRequest: { ...editedValues.verificationRequest, [key]: value },
        });
    };

    return (
        <div className='widget-trade-status-table-drawer__content'>
            <AccountsInfo
                value={(() => {
                    if (account.customerType === 'Entity') {
                        return account.verificationRequest.entityName;
                    }
                    return `${account.verificationRequest.firstName} ${account.verificationRequest.lastName}`;
                })()}
                fieldName='Name'
            />
            <AccountsInfo
                value={editedValues.verificationRequest.street}
                fieldName='Street'
                editableField='input'
                onChange={onChange}
                keyName='street'
            />
            <AccountsInfo
                value={editedValues.verificationRequest.city}
                fieldName='City'
                editableField='input'
                onChange={onChange}
                keyName='city'
            />
            <AccountsInfo
                value={editedValues.verificationRequest.state}
                fieldName='State'
                editableField='input'
                onChange={onChange}
                keyName='state'
            />
            <AccountsInfo
                value={editedValues.verificationRequest.country}
                fieldName='Country'
                editableField='input'
                onChange={onChange}
                keyName='country'
            />
            <AccountsInfo
                value={editedValues.verificationRequest.postalCode}
                fieldName='Postal Code'
                editableField='input'
                onChange={onChange}
                keyName='postalCode'
            />
            <AccountsInfo
                value={editedValues.verificationRequest.passport}
                fieldName='Passport'
                editableField='input'
                onChange={onChange}
                keyName='passport'
            />
            {account.customerType === 'Entity' ? (
                <AccountsInfo
                    value={account?.verificationRequest.entityTaxId}
                    fieldName='TIN'
                />
            ) : (
                <AccountsInfo
                    value={account?.verificationRequest.ssn}
                    fieldName='SSN'
                />
            )}

            <AccountsInfo
                value={editedValues.verificationRequest.phone || account?.verificationRequest.phone}
                fieldName='Phone'
                editableField='input'
                onChange={onChange}
                keyName='phone'
            />
            <AccountsInfo
                className='noBorder center'
                value={moment(account?.verificationRequest.dob).format('MMM D, YYYY [at] HH:mm')}
                fieldName='DOB'
            />
        </div>
    );
};
